import {
  IPolicyPremiumDetailsData,
  IUpdatePolicyPremiumDetailsRequest,
} from 'types/order/title/IPolicyPremiumDetailsResponse';
import { UUID } from 'types/shared/UUID';
import { BaseAPI } from '../../BaseApi';
import { eAPITags } from '../../eAPITags';

interface UpdatePolicyPremiumDetailsParams {
  orderId: UUID;
  updateRequest: IUpdatePolicyPremiumDetailsRequest;
}

export const PolicyPremiumDetailsAPI = BaseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getPolicyPremiumDetails: builder.query<IPolicyPremiumDetailsData, UUID>({
      query: (orderId) => `/cd_items/v3/pricing/${orderId}`,
      providesTags: (_, __, orderId) => [{ id: orderId, type: eAPITags.OrderPolicyPremiumDetails }],
    }),

    updatePolicyPremiumDetails: builder.mutation<IPolicyPremiumDetailsData, UpdatePolicyPremiumDetailsParams>({
      query: ({ orderId, updateRequest }) => ({
        url: `/cd_items/v3/pricing/${orderId}`,
        method: 'PUT',
        body: updateRequest,
      }),
      invalidatesTags: (_, __, { orderId }) => [{ id: orderId, type: eAPITags.OrderPolicyPremiumDetails }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetPolicyPremiumDetailsQuery, useUpdatePolicyPremiumDetailsMutation } = PolicyPremiumDetailsAPI;
